'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002413 from "./presto.-Agent-View$$anon$13.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dUpload$002dFile$002dRequest$0024 from "./presto.-Agent-View$-Upload-File-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$12() {
  this.awC = null;
  this.awu = null;
  this.awv = false;
  this.awD = null;
  this.awE = false;
  this.awH = null;
  this.awA = null;
  this.awB = false;
  this.aww = null;
  this.awx = false;
  this.awy = null;
  this.awz = false;
  this.awF = false;
  this.awG = false;
  this.awC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.awH = "UploadFileRequest";
}
export { $c_Lpresto_AgentView$$anon$12 as $c_Lpresto_AgentView$$anon$12 };
$p = $c_Lpresto_AgentView$$anon$12.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$12;
/** @constructor */
function $h_Lpresto_AgentView$$anon$12() {
}
export { $h_Lpresto_AgentView$$anon$12 as $h_Lpresto_AgentView$$anon$12 };
$h_Lpresto_AgentView$$anon$12.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.awC;
});
$p.M = (function() {
  if ((!this.awv)) {
    this.awu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.awv = true;
  }
  return this.awu;
});
$p.O = (function() {
  if ((!this.awE)) {
    this.awD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.awE = true;
  }
  return this.awD;
});
$p.D = (function() {
  return this.awH;
});
$p.t = (function() {
  if ((!this.awB)) {
    this.awA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("text", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.awB = true;
  }
  return this.awA;
});
$p.N = (function() {
  if ((!this.awx)) {
    this.aww = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fi(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.awx = true;
  }
  return this.aww;
});
$p.Q = (function() {
  if ((!this.awz)) {
    this.awy = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002413.$c_Lpresto_AgentView$$anon$13();
    this.awz = true;
  }
  return this.awy;
});
$p.v = (function() {
  if ((!this.awG)) {
    this.awF = false;
    this.awG = true;
  }
  return this.awF;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee84) => ((p) => \u03b4scrutinee84.cGU(p)))($j_presto$002e$002dAgent$002dView$0024$002dUpload$002dFile$002dRequest$0024.$m_Lpresto_AgentView$UploadFileRequest$())));
});
var $d_Lpresto_AgentView$$anon$12 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$12, "presto.AgentView$$anon$12", ({
  DG: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$12 as $d_Lpresto_AgentView$$anon$12 };
//# sourceMappingURL=presto.-Agent-View$$anon$12.js.map
